'use strict';

export default {

    positionOf(anchor) {
        let to = 0;

        if(typeof anchor == 'undefined') {
            to = 0;
        }
        else if(anchor instanceof jQuery) {
            if(anchor.length) {
                to = anchor.offset().top;
            }
        }
        else {
            to = anchor;
        }

        $('html,body').animate({scrollTop: to}, 'fast');
    }
};



// WEBPACK FOOTER //
// ./app/Resources/assets/js/components/scrollTo.js